import React from "react";
import { Divider, Grid } from "@material-ui/core";

import AdminLayout from "../../layouts/AdminLayout";
import Breadcrumb from "../../breadcrumb/Breadcrumb";
import PrimaryFilterSection from "./templates/primary-filters";
import { Formik } from "formik";

import PageDomain from "./domain";
import PaginationView from "./templates/pagination-view";
import AdSummeryListView from "./templates/ad-summery-list-view";
import { UserListContext } from "../../../../context/follow-up-widgets";
import SideView from "./components/side-view";
import { NotificationContainer } from "react-notifications";

import { useSubscribe } from "../../../../hooks/publisher-subscriber";

import { isEmpty } from "lodash";
import { scrollIntoElement } from "../../../../utils";

import "./style.css";
import ResultsActionView from "./templates/results-action-view";

export const API_STATUSES = Object.freeze({
  SUCCESS: "success",
  PENDING: "pending",
  ERROR: "error",
});

const FollowUpNewWidget = () => {
  const initialValues = PageDomain.buildModelFromFormModel();

  const [results, setResults] = React.useState([]);
  const [responseStatus, setResponseStatus] = React.useState();
  const [sideViewInfo, setSideViewInfo] = React.useState({});
  const [currentSideView, setCurrentSideView] = React.useState({});

  const onSubmitForm = async (values, { setFieldValue }) => {
    try {
      setResponseStatus(API_STATUSES.PENDING);
      await PageDomain.setSearchResults({
        values,
        setResults,
        setFieldValue,
      });
      setResponseStatus(API_STATUSES.SUCCESS);
      if (values.pageNumber !== 1) {
        scrollIntoElement({
          id: "new-widget-follow-up-breadcrumb",
          block: "start",
          behavior: "instant",
        });
      }
    } catch (error) {
      setResponseStatus(API_STATUSES.ERROR);
    }
  };

  useSubscribe("openSideView", (currentView) => {
    setCurrentSideView(currentView);
  });

  useSubscribe("closeSideView", () => {
    setCurrentSideView({});
  });

  return (
    <AdminLayout>
      <UserListContext.Provider
        value={{
          results,
          setResults,
          responseStatus,
          setResponseStatus,
          setSideViewInfo,
          sideViewInfo,
          currentSideView,
        }}
      >
        <Grid
          className="content-col"
          style={{ marginBottom: "0", padding: "0" }}
        >
          <Breadcrumb mainTitle="Ads" title="Search" />
          <Formik initialValues={initialValues} onSubmit={onSubmitForm}>
            <Grid container className="follow-up-new-widget py-24">
              <Grid
                item
                container
                direction="column"
                xs={!isEmpty(currentSideView) ? 8 : 10}
                className="gap-y-16 px-16"
              >
                <PrimaryFilterSection />
                <PaginationView />
                <Divider className="w-full" />
                <ResultsActionView />
                <AdSummeryListView />
                <PaginationView />
              </Grid>
              {!isEmpty(currentSideView) && <SideView />}
            </Grid>
          </Formik>
        </Grid>
      </UserListContext.Provider>
      <NotificationContainer />
    </AdminLayout>
  );
};

export default FollowUpNewWidget;
